module.exports = __webpack_public_path__ + "media/images/display/notfound-64a1702533d3da17d09236a3bdd146a4.svg";